export const privacyPage = () =>
  import("./PrivacyPage").then((m) => ({ Component: m.PrivacyPage }));
